import { DataSet } from './data-set';

export class Column {
  public title: string = '';
  public type: string = '';
  public class: string = '';
  public width: string = '';
  public isSortable: boolean = false;
  public isEditable: boolean = true;
  public isAddable: boolean = true;
  public isFilterable: boolean = false;
  public sortDirection: string = '';
  public defaultSortDirection: string = '';
  public editor: { type: string, config: any, component: any } = {
    type: '',
    config: {},
    component: null
  };
  public filter: { type: string, config: any } = { type: '', config: {} };
  public renderComponent: any = null;
  public compareFunction: Function;
  public valuePrepareFunction: Function;
  public filterFunction: Function;
  public onComponentInitFunction: Function;
  public toolTip = '';
  public maxLength: number;

  constructor(
    public id: string,
    protected settings: any,
    protected dataSet: DataSet
  ) {
    this.process();
  }

  public getOnComponentInitFunction(): Function {
    return this.onComponentInitFunction;
  }

  public getCompareFunction(): Function {
    return this.compareFunction;
  }

  public getValuePrepareFunction(): Function {
    return this.valuePrepareFunction;
  }

  public getFilterFunction(): Function {
    return this.filterFunction;
  }

  public getConfig(): any {
    return this.editor && this.editor.config;
  }

  public getFilterType(): any {
    return this.filter && this.filter.type;
  }

  public getFilterConfig(): any {
    return this.filter && this.filter.config;
  }

  public prepareType(): string {
    return this.settings['type'] || this.determineType();
  }

  public prepareSortDirection(): string {
    return this.settings['sort'] === 'desc' ? 'desc' : 'asc';
  }

  public determineType(): string {
    // TODO: determine type by data
    return 'text';
  }

  protected process() {
    this.title = this.settings['title'];
    this.class = this.settings['class'];
    this.width = this.settings['width'];
    this.type = this.prepareType();
    this.editor = this.settings['editor'];
    this.filter = this.settings['filter'];
    this.renderComponent = this.settings['renderComponent'];
    this.toolTip = this.settings['toolTip'];
    this.maxLength = this.settings['maxLength'];

    this.isFilterable =
      typeof this.settings['filter'] === 'undefined'
        ? true
        : !!this.settings['filter'];
    this.defaultSortDirection =
      ['asc', 'desc'].indexOf(this.settings['sortDirection']) !== -1
        ? this.settings['sortDirection']
        : '';
    this.isSortable =
      typeof this.settings['sort'] === 'undefined'
        ? true
        : !!this.settings['sort'];
    this.isEditable =
      typeof this.settings['editable'] === 'undefined'
        ? true
        : !!this.settings['editable'];
    this.isAddable =
      typeof this.settings['addable'] === 'undefined'
        ? true
        : !!this.settings['addable'];
    this.sortDirection = this.prepareSortDirection();

    this.compareFunction = this.settings['compareFunction'];
    this.valuePrepareFunction = this.settings['valuePrepareFunction'];
    this.filterFunction = this.settings['filterFunction'];
    this.onComponentInitFunction = this.settings['onComponentInitFunction'];
  }
}
